import { Component, OnInit, Input } from '@angular/core';
import { Course } from 'lms-api';
import { ShoppingCartService } from 'lms-api';

@Component({
  selector: 'app-course-view-grid',
  templateUrl: './course-view-grid.component.html',
  styleUrls: ['./course-view-grid.component.scss']
})
export class CourseViewGridComponent implements OnInit {
  @Input() course: Course;

  constructor(public cartService: ShoppingCartService) { }

  ngOnInit() {
  }
}
